<template>
  <div>
    <table
      v-for="(it , index) in items"
      :key="index+'tt'"
      class="left TB_COLLAPSE"
      :class="[cloce]"
      width="12.5%"
    >
      <thead>
        <th width="40%">{{tableHead[index]}}</th>
        <th width="60%">賠率占成</th>
      </thead>
      <tbody>
        <tr v-for="(item, key) in it" :key="key+'tc'" class="tc">
          <th :class="item.colour">
            <h4>{{ item.name }}</h4>
          </th>
          <td :class="{'isstop0': item.isstop == 2 || item.isstop == 0 }">
            <table-adjust-odds
              :table="item"
              @go_live_show_bridge="go_live_show_bridge"
              :addbetcal="false"
            ></table-adjust-odds>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { Utile } from "utils";
import { mapGetters, mapState, mapActions } from "vuex";
import checkpath from "./mixins/checkPath.js";
import liveshowSixmark from '@/mixins/liveshow-sixmark.js'
export default {
  name: "liveshow-tailcontact",
  mixins: [checkpath, liveshowSixmark],
  data () {
    return {
      items: [],
      tableHead: [
        '二尾连中',
        '二尾连不中',
        '三尾连中',
        '三尾连不中',
        '四尾连中',
        '四尾连不中',
        '五尾连中',
        '五尾连不中',
      ],
    };
  },
  created () {
    this.getItems();
  },
  computed: {
    ...mapGetters(["getliveshow", "getgameid"]),
    KeyName () {
      return this.liveshowPath ? "supododtwo" : "linksupododtwo";
    }
  },
  watch: {
    "getliveshow.chgbaco" (val) {
      this.getItems();
    },
    "$route.query.page" (val) {
      this.getItems();
    }
  },
  methods: {
    async getItems () {
      try {
        const meta = this.$route.meta
        const obj = {
          gameid: this.getgameid,
          page: meta.page,
          odd: meta.odd,
          baco: this.getliveshow.chgbaco,
          site: this.getliveshow.siteSelect
        }
        if (this.getliveshow.siteSelect == '') {
          this.items = []
          return
        }
        const res = await this.$axios.liveshow[this.KeyName](obj);
        if ('status' in res && res.status === 0) return
        this.IsstopColor(res)
        const array = res.map(it => (it.clas = 1, it));
        this.items = Utile.chunk(array, 10);
      } catch (error) {
        console.log(error);

        this.$Message.error("網路異常:(S3013)");
      }
    },
    readyaxiso () {
      if (!this.$route.name.includes('tailcontact')) return
      this.getItems();
    },
    go_live_show_bridge () {
      this.$emit("refresh");
    }
  }
};
</script>